import React, { useState } from 'react'
import style from './TodoWrapper.module.css'
import TodoForm from '../TodoForm/TodoForm'
import {v4 as uuidv4} from 'uuid';
import EditTodoForm from '../EditTodoForm/EditTodoForm';
import Todo from '../Todo/Todo';

function TodoWrapper() {
  const [todos,setTodos]=useState([]);

  const addTodo = (todo) =>{
    setTodos([...todos,{id:uuidv4(),task:todo,completed:false,isEditing:false}])
  }
  const deleteTodo=(id)=>{
    return setTodos(todos.filter((todo)=> todo.id !==id))
  }
  const toggleComplete= (id) =>{
    return setTodos(todos.map((todo)=>todo.id===id?{...todo,completed:!todo.completed} : todo))
  }
  const editTodo = (id) =>{
    return setTodos(todos.map((todo)=>todo.id===id?{...todo,isEditing:!todo.isEditing}:todo))
  }
  const editTask = (task,id)=>{
   setTodos(
    todos.map((todo)=>todo.id === id ?{...todo,task,isEditing:!todo.isEditing}:todo))
  }
  console.log(todos);
  return (
    <div className={style.todowrapper}>
      <div className={style.head}>
        <h1 className={style.heading}>Web Development Task!</h1>
        <TodoForm addTodo={addTodo}/>
      </div>
        <div className={style.taskWrapper}>
        {
          todos.map((todo)=> todo.isEditing ? (
            <EditTodoForm editTodo={editTask} task={todo}/>
          ):(
            <Todo
              key={todo.id}
              task={todo}
              deleteTodo={deleteTodo}
              editTodo={editTodo}
              toggleComplete={toggleComplete}
            />
          )
        )
        }
        </div>
    </div>
  )
}

export default TodoWrapper